import React from 'react'
import ProfileInput from '../common/ProfileInput'
import {
  presenceErrorClass,
} from 'servos/formValidations'

class AusPassport extends React.Component {
  render() {
    const {
      id,
      handleInput,
      errors,
      ausPassportNumber,
    } = this.props

    return (
      <div className='w-50 ml-2 pl-3 pt-2 border-left border-green'>
        <div className='form-group'>
          <div className="row mt-2">
            <ProfileInput
              id={id}
              label='Australia passport number'
              value={ausPassportNumber}
              handleInput={handleInput}
              errors={errors}
              className='col-12'
            />
          </div>
        </div>
      </div>
    )
  }
}

export default AusPassport;
